import { IAuditLog } from 'types/entities';
import { EntityService } from '../entity.service';


class AuditLogsService extends EntityService<IAuditLog> {
  readonly entityName = 'audit_log';
}

export default new AuditLogsService();
